import React from 'react';
import {useTranslation} from 'react-i18next';
import PropTypes from 'prop-types';

import FormField from 'components/FormField';
import {Select, Option} from 'components/Select';
import useUniqueId from 'hooks/useUniqueId';

const DownloadPermissionField = ({
	id,
	download,
	variant,
	horizontal,
	bold,
	onChange,
}) => {
	const {t} = useTranslation();
	const uniqueId = useUniqueId(id);

	const downloadOptions = [
		{value: 'disabled', title: t('state_disabled')},
		{value: 'enabled', title: t('state_enabled')},
		{value: 'required', title: t('state_required_no_file_preview')},
	];

	return (
		<FormField
			as="span"
			label={t('form_preview_download_colon')}
			labelId={uniqueId}
			horizontal={horizontal}
			horizontalLabelWidth={250}
			bold={bold}
		>
			<Select
				labelledById={uniqueId}
				size="medium"
				variant={variant}
				menuPlacement="top"
				value={download}
				onChange={selectedItem => onChange(selectedItem)}
				ml={variant === 'transparent' && '-xxs'}
			>
				{downloadOptions.map(option => (
					<Option key={option.value} value={option.value}>
						{option.title}
					</Option>
				))}
			</Select>
		</FormField>
	);
};

export default DownloadPermissionField;

DownloadPermissionField.defaultProps = {
	horizontal: true,
	bold: true,
	variant: 'transparent',
};

DownloadPermissionField.propTypes = {
	id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	download: PropTypes.string,
	variant: PropTypes.string,
	horizontal: PropTypes.bool,
	onChange: PropTypes.func.isRequired,
};
